import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { useMaTransactionsContext } from '../../../MaTransactionsContext';
import { MA_TRANSACTIONS_QUERY } from '../operations';

export const useGetTransactions = () => {
  const { filterVariables } = useMaTransactionsContext();

  const [fetchTransactions, { data, loading, called, error }] = useLazyQuery(MA_TRANSACTIONS_QUERY);
  const getTransactions = useCallback(
    ({ deals, page, perPage, order, orderBy }) => {
      const filters = {
        ...filterVariables,
        deals,
      };
      const pagination = {
        page: page + 1,
        perPage,
        order,
        orderBy,
      };
      fetchTransactions({ variables: { filters, pagination } });
    },
    [fetchTransactions, filterVariables],
  );

  return {
    getTransactions,
    data,
    transactions: data?.maTransactions?.transactions || [],
    totalCount: data?.maTransactions?.totalCount,
    called,
    loading,
    error,
  };
};
